import { computed } from 'vue';
import { useStoreGetters } from 'dashboard/composables/store';

/**
 * Composable to determine if the current user is an installation Super Admin.
 * @returns {Boolean} - True if the current user is an installation Super Admin, false otherwise.
 */
export function useInstallationSuperAdmin() {
  const getters = useStoreGetters();

  const isInstallationSuperAdmin = computed(
    () => getters.getCurrentUser.value?.type === 'SuperAdmin'
  );

  return {
    isInstallationSuperAdmin,
  };
}
